export default () => {
  try {
    const table = new URL(location.href).searchParams.get('table');

    if (table) {
      sessionStorage.setItem('table', table);
    }
  } catch (e) {
    //
  }
};
